import React from 'react';

import { Modal as AntdModal } from 'antd';

import { ConfigurationDto } from 'lib_api/lib/api/gen';

import { FieldDisplay } from 'components/FieldDisplay/FieldDisplay';
import { BaseModalWidthUtils } from 'utils/BaseModalWidthUtils';
import { LABEL_ID_CORRELATION } from 'utils/global';

import { configuration_labels } from '../../labels';

import './ModalDetails.less';

interface ModalDetailsProps {
  configuration: ConfigurationDto;
  visible: boolean;
  close: () => void;
}

function ModalDetails({
  configuration,
  visible,
  close,
}: ModalDetailsProps): React.ReactElement {
  return (
    <AntdModal
      open={visible}
      onCancel={close}
      footer={null}
      destroyOnClose={true}
      width={BaseModalWidthUtils.xLargeWidth}
      maskClosable={false}
      className="modalDetails"
    >
      <FieldDisplay
        labelClass={'labelDetail'}
        label={LABEL_ID_CORRELATION}
        value={configuration.idCorrelation}
      />
      <FieldDisplay
        labelClass={'labelDetail'}
        label={configuration_labels.SERVICE}
        value={configuration.microServiceName}
      />
      <FieldDisplay
        labelClass={'labelDetail'}
        label={configuration_labels.NOM}
        value={configuration.fullName}
        additionalValueClassName={'multiLineValue'}
      />
      <FieldDisplay
        labelClass={'labelDetail'}
        label={configuration_labels.DESCRIPTION}
        value={configuration.description}
        additionalValueClassName={'multiLineValue'}
      />
      <FieldDisplay
        labelClass={'labelDetail'}
        label={configuration_labels.VALEUR}
        value={configuration.value}
        additionalValueClassName={'textValue'}
      />
      <FieldDisplay
        labelClass={'labelDetail'}
        label={configuration_labels.LECTURE_SEULE}
        value={configuration.readOnly ? 'Oui' : 'Non'}
      />
    </AntdModal>
  );
}

export default ModalDetails;
